import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

import axios from 'axios';
import jwt from 'expo-jwt';

import { useSelector, useDispatch } from 'react-redux';
import { purgeOrganiztion, setOrganizationData, setUserToken, setUserData, setCdn, setVsCdn } from '@modules/organization';
import { purgeChapter } from '@modules/chapter';
import { purgeEditor } from '@modules/editor';
import { purgeMedia } from '@modules/media';
import { purgeSubtitle } from '@modules/subtitle';
import Loading from '../../components/_commons/Loading';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function RemoteAuth({ orgList }) {
    const { key } = useParams();  // URL 파라미터에서 key를 가져옴
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [redirectUrl, setRedirectUrl] = useState(null);
    const [wrongPopKey, setWrongPopKey] = useState(false);
    const [token, setToken] = useState('');
    const [orgCode, setOrgCode] = useState('');
    const [tmpUserData, setTmpUserData] = useState({});

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        setRedirectUrl(queryParams.get('redirect'))

        var data = {
            "popupKey": key
        };

        var config = {
            method: 'post',
            url: API_URL + '/' + API_VERSION + '/auth/popup',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then((response) => {

                dispatch(purgeOrganiztion());
                dispatch(purgeMedia());
                dispatch(purgeOrganiztion());
                dispatch(purgeEditor());
                dispatch(purgeSubtitle());
                dispatch(purgeChapter());

                var data = response.data;
                var orgData = response.data.organizationData;
                var organizationData = {
                    organization_name: orgData.organization_name,
                    organization_code: orgData.organization_code
                }
                setOrgCode(orgData.organization_code);
                setToken(data.token);
                dispatch(setOrganizationData(organizationData));
                dispatch(setCdn(orgData.media_cdn));
                dispatch(setVsCdn(orgData.media_vs_cdn));
            })
            .catch((error) => {
                console.log(error);
                setWrongPopKey(true);
            });
    }, []);

    useEffect(() => {
        if (token && orgCode && orgList.length > 0) {

            var openKey = '';
            const matchingOrg = orgList.find(org => org.value === orgCode);
            if (matchingOrg) {
                openKey = matchingOrg.open_token;
            }

            var extraToken = token.slice(-7);
            var userToken = token.replace(extraToken, '');
            var decodedUserData = jwt.decode(userToken, openKey + extraToken);
            var userData = {}; // 디코딩 된 사용자 정보
            for (const [key, value] of Object.entries(decodedUserData)) {
                userData[key] = decodeURI(value);
            }

            setTmpUserData({ ...userData });
            dispatch(setUserData({ ...userData }));
        }
    }, [token, orgCode, orgList])

    useEffect(() => {
        if (redirectUrl && Object.keys(tmpUserData).length > 0) {
            navigate(redirectUrl);
            dispatch(setUserToken(token));
        }
    }, [redirectUrl, tmpUserData])

    return (
        wrongPopKey ?
            <div style={{ 'paddingTop': '30vh', 'transform': 'translate(50vw)' }}>
                <Typography variant="h6" color="error"> {t('common.unauthorized_user')} </Typography>
            </div>
            :
            Object.keys(tmpUserData).length > 0 ?
                <div>
                    <Typography variant="body1"> {t('common.redirecting')} </Typography>
                </div>
                :
                <Loading />
    );
}

export default RemoteAuth;